import * as React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronUp, faChevronDown} from '@fortawesome/free-solid-svg-icons'

import {Button} from '@frontrow/console/src/components/button'
import {type PolyfilledEvent} from '@frontrow/console/src/polyfills'

type Props = {
  expand: boolean
  onClick: (e: PolyfilledEvent) => void
}

export function ExpandChevronButton(props: Props): React.ReactElement {
  const {expand, onClick} = props

  return (
    <Button
      onClick={onClick}
      style="tertiary"
      addClass="border-none shadow-none p-0 m-0 text-[20px] bg-transparent hover:bg-transparent focus:bg-transparent focus:outline-none"
      dataTest="expand-chevron-button"
    >
      {expand ? (
        <FontAwesomeIcon icon={faChevronDown} aria-hidden="true" />
      ) : (
        <FontAwesomeIcon icon={faChevronUp} aria-hidden="true" />
      )}
    </Button>
  )
}
